import { MusicGenreContainer, MusicGenreTitle, MusicGenreTitleContainer } from './styles';

interface IMusicGenreProps {
  color?: string;
  title?: string;
  index: number;
}

const MusicGenre = ({ color, title, index }: IMusicGenreProps) => (
  <MusicGenreContainer
    index={index}
    color={color as string}
    initial={{
      opacity: 0,
      y: 3,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    transition={{
      type: 'spring',
      delay: 0.2 + index * 0.1,
    }}
    viewport={{ once: true }}
  >
    <MusicGenreTitleContainer color={color as string}>
      <MusicGenreTitle>{title}</MusicGenreTitle>
    </MusicGenreTitleContainer>
  </MusicGenreContainer>
);

export default MusicGenre;
